/**
 * Force logout — clears all auth state and redirects to login.
 *
 * Used by:
 * - AuthGuard (session validation failure)
 * - apiClient (401 after refresh token expired)
 * - Manual logout handlers (nav-user)
 */

import { markLoggingOut } from "@/lib/logout-state";

export function forceLogout(queryClient) {
  // Set in-memory flag FIRST — stops any concurrent token refresh from
  // writing a new token back to localStorage after we've cleared it.
  markLoggingOut();

  localStorage.removeItem("token");
  localStorage.removeItem("csrfToken");

  // Clear PMS auth cookies (both localhost-prefixed and production variants)
  document.cookie = "pms_refresh_token=; path=/api/v1/auth; max-age=0";
  document.cookie = "csrf-token=; path=/; max-age=0";
  document.cookie = "pms_logged_in=; path=/; max-age=0";

  if (queryClient) {
    queryClient.clear();
  }

  window.location.href = "/";
}
